import { render, staticRenderFns } from "./ViewMoreButton.vue?vue&type=template&id=1fa9569a&scoped=true"
var script = {}
import style0 from "./ViewMoreButton.vue?vue&type=style&index=0&id=1fa9569a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa9569a",
  null
  
)

export default component.exports